import i18n from "@/i18n";

const routes = {
  path: "/shot",
  name: "Shot",
  component: () =>
    import(/* webpackChunkName: "manager" */ "@/views/stats/shot/Main"),
  children: [
    {
      path: "shotstats",
      alias: "",
      name: "ShotStats",
      component: () =>
        import(
          /* webpackChunkName: "manager" */ "@/views/stats/shot/Shotstats"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle:
          i18n.t("page.admin.shot") + " " + i18n.t("title.admin.summary"),
        step: [i18n.t("page.admin.stats"), i18n.t("page.admin.shot")],
        menu_num: 8,
        sub_menu_num: 81,
        location: "/shot/shotstats",
      },
    },
    {
      path: "plyaerstats",
      name: "PlyaerStats",
      component: () =>
        import(
          /* webpackChunkName: "manager" */ "@/views/stats/player/Plyaerstats"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle:
          i18n.t("page.admin.playing_time") +
          " " +
          i18n.t("title.admin.summary"),
        step: [i18n.t("page.admin.stats"), i18n.t("page.admin.playing_time")],
        menu_num: 8,
        sub_menu_num: 82,
        location: "/player/playingstats",
      },
    },
    {
      path: "venuestats",
      name: "VenueStats",
      component: () =>
        import(
          /* webpackChunkName: "manager" */ "@/views/stats/venue/Venuestats"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle:
          i18n.t("page.admin.venue") + " " + i18n.t("title.admin.summary"),
        step: [i18n.t("page.admin.stats"), i18n.t("page.admin.venue")],
        menu_num: 8,
        sub_menu_num: 83,
        location: "/venue/venuestats",
      },
    },
    {
      path: "memberstats",
      name: "MemberStats",
      component: () =>
        import(
          /* webpackChunkName: "manager" */ "@/views/stats/member/Memberstats"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle:
          i18n.t("page.admin.member") + " " + i18n.t("title.admin.summary"),
        step: [i18n.t("page.admin.stats"), i18n.t("page.admin.member")],
        menu_num: 8,
        sub_menu_num: 84,
        location: "/member/memberstats",
      },
    },
    {
      path: "coursestats",
      name: "CourseStats",
      component: () =>
        import(
          /* webpackChunkName: "manager" */ "@/views/stats/course/Coursestats"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle:
          i18n.t("page.admin.course") + " " + i18n.t("title.admin.summary"),
        step: [i18n.t("page.admin.stats"), i18n.t("page.admin.course")],
        menu_num: 8,
        sub_menu_num: 85,
        location: "/course/coursestats",
      },
    },
  ],
};

export default routes;
